import axios from 'axios';
import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';
import { setNewsAttachmentUploadProgress } from './gnnSlice';

export const gnnApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNews: builder.query({
      query: ({ category, page = 1, pageSize = 4, searchTerm = '', userEmpCode }) => {
        return `${ENDPOINTS.GNN.GET_ALL_NEWS
          }${page}/${pageSize}/${category}/${userEmpCode}?searchTerm=${encodeURIComponent(searchTerm)}`;
      },
      transformResponse: (response) => {
        const resonseData = response.newsData.map((news) => {
          const fileName = news.authorUserPhoto ? news.authorUserPhoto.split('/').pop() : null;
          const encodedFileName = fileName ? encodeURIComponent(fileName) : null;
          const fullPhotoUrl = encodedFileName
            ? `${process.env.REACT_APP_BASE_PHOTO_URL}${encodedFileName}`
            : null;

          return {
            ...news,
            authorUserPhoto: fullPhotoUrl, // replace the original path with the full URL
          };
        });
        const updatedNewsData = {
          data: resonseData,
          totalCount: response.totalCount,
        };


        console.log('News Data:--', updatedNewsData);

        return updatedNewsData;
      },
      providesTags: (result, error, { category, page, searchTerm }) => {
        return result
          ? [{ type: 'News', id: 'LIST' }, ...result.data.map(({ _id }) => ({ type: 'News', id: _id }))]
          : [{ type: 'News', id: 'LIST' }];
      },
    }),
    getPublicNews: builder.query({
      query: ({ page = 1, pageSize = 4 }) => {
        return `${ENDPOINTS.PUBLIC.GNN}${page}/${pageSize}`;
      },
      transformResponse: (response) => {
        return {
          data: response.newsData,
          totalCount: response.totalCount,
        };
      },
      providesTags: (result) =>
        result
          ? [{ type: 'News', id: 'LIST' }, ...result.data.map(({ _id }) => ({ type: 'News', id: _id }))]
          : [{ type: 'News', id: 'LIST' }],
    }),
    getNewsById: builder.query({
      query: (id) => `${ENDPOINTS.GNN.GET_NEWS_BY_ID}${id}`,
      transformResponse: (response) => {
        const responseData = response.map((news) => {
          const newsPhotoFileName = news.authorUserPhoto ? news.authorUserPhoto.split('/').pop() : null;
          const newsEncodedFileName = newsPhotoFileName ? encodeURIComponent(newsPhotoFileName) : null;
          const newsFullPhotoUrl = newsEncodedFileName
            ? `${process.env.REACT_APP_BASE_PHOTO_URL}${newsEncodedFileName}`
            : null;

          const updatedComments = news.comments?.map((comment) => {
            const commentPhotoFileName = comment.authorUserPhoto ? comment.authorUserPhoto.split('/').pop() : null;
            const commentEncodedFileName = commentPhotoFileName ? encodeURIComponent(commentPhotoFileName) : null;
            const commentFullPhotoUrl = commentEncodedFileName
              ? `${process.env.REACT_APP_BASE_PHOTO_URL}${commentEncodedFileName}`
              : null;

            return {
              ...comment,
              authorUserPhoto: commentFullPhotoUrl,
            };
          }) || [];

          return {
            ...news,
            authorUserPhoto: newsFullPhotoUrl,
            comments: updatedComments,
          };
        });

        console.log('News Data::::::::::::::::::--', responseData);
        return responseData;
      },
      providesTags: (result, error, id) => [{ type: 'News', id }],
    }),
    postNews: builder.mutation({
      queryFn: async (formData, api) => {
        try {
          const token = api.getState().auth.token;
          const result = await axios.post(`${process.env.REACT_APP_BASE_URL}${ENDPOINTS.GNN.POST_NEWS}`, formData, {
            //...other options like headers here
            headers: {
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress: (upload) => {
              //Set the progress value to show the progress bar
              let uploadloadProgress = Math.round((100 * upload.loaded) / upload.total);
              // api.dispatch(setUploadProgress(uploadloadProgress ));
              console.log(uploadloadProgress);
              api.dispatch(setNewsAttachmentUploadProgress({ progress: uploadloadProgress, uploadStarted: true }));
            },
          });
          return { data: result.data };
        } catch (axiosError) {
          let err = axiosError;
          return {
            error: {
              status: err.response?.status,
              data: err.response?.data || err.message,
            },
          };
        }
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        console.log('upload started');
        dispatch(setNewsAttachmentUploadProgress({ progress: 0, uploadStarted: true }));

        try {
          const { data } = await queryFulfilled;
          dispatch(setNewsAttachmentUploadProgress({ progress: null, uploadStarted: false }));
        } catch (err) {
          dispatch(setNewsAttachmentUploadProgress({ progress: null, uploadStarted: false }));
        } finally {
          console.log('upload completed');
        }
      },
      invalidatesTags: (result, error) => {
        console.log('news posted', result);
        return [
          { type: 'News', id: 'LIST' },
          { type: 'News', id: result?.news?._id },
        ];
      },
    }),
    updateNews: builder.mutation({
      query: ({ id, formData }) => ({
        url: `${ENDPOINTS.GNN.UPDATE_NEWS}${id}`,
        method: 'PUT',
        body: formData, // Pass the entire formData object directly
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'News', id }],
    }),
    deleteNews: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.GNN.DELETE_NEWS}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'News', id }],
    }),
    likeNews: builder.mutation({
      query: ({ id, empCodeData }) => ({
        url: `/gnn/${id}/like`,
        method: 'POST',
        body: empCodeData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'News', id }],
    }),
    unlikeNews: builder.mutation({
      query: ({ id, empCodeData }) => ({
        url: `${ENDPOINTS.GNN.UNLIKE_NEWS.replace(':id', id)}`,
        method: 'DELETE',
        body: empCodeData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'News', id }],
    }),
    commentNews: builder.mutation({
      query: ({ id, commentData }) => ({
        url: `${ENDPOINTS.GNN.COMMENT_NEWS.replace(':id', id)}`,
        method: 'POST',
        body: commentData,
      }),
      invalidatesTags: (result, error, { newsId }) => [{ type: 'News', id: newsId }],
    }),
    deleteGnnComment: builder.mutation({
      query: ({ newsId, commentId }) => ({
        url: `/gnn/${newsId}/comment/${commentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { newsId }) => [{ type: 'News', id: newsId }],
    }),
    viewNews: builder.mutation({
      query: ({ id, empCodeData }) => ({
        url: `${ENDPOINTS.GNN.VIEW_NEWS.replace(':id', id)}`,
        method: 'POST',
        body: empCodeData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'News', id }],
    }),
    markAsTop5News: builder.mutation({
      query: ({ id }) => ({
        url: `${ENDPOINTS.GNN.MARK_AS_TOP_5}${id}`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'News', id: 'LIST' }],
    }),
    getTrendingNews: builder.query({
      query: () => {
        return `${ENDPOINTS.GNN.TRENDING_NEWS}`;
      },
      providesTags: [{ type: 'News', id: 'LIST' }],
    }),
    getTopNews: builder.query({
      query: () => {
        return `${ENDPOINTS.GNN.TOP_NEWS}`;
      },
      providesTags: [{ type: 'News', id: 'LIST' }],
    }),
    getCertificateData: builder.query({
      query: () => (
        {         
        url: ENDPOINTS.EMPLOYEE.CERTIFICATELIST,
        method: 'GET',
        
      }),      
    }),
    getNewOpenings: builder.query({
      query: () => {
        return `${ENDPOINTS.GNN.NEW_OPENINGS}`;
      },
      providesTags: [{ type: 'NewOpenings' }],
    }),
    getNewTechnicalOpenings: builder.query({
      query: () => {
        return 'https://connectapi.thegatewaycorp.com/api/v1/careers/getCurrentOpenings?category=Technical';
      },
      providesTags: [{ type: 'NewOpenings' }],
    }),
    getNewNonTechnicalOpenings: builder.query({
      query: () => {
        return 'https://connectapi.thegatewaycorp.com/api/v1/careers/getCurrentOpenings?category=Non-Technical';
      },
      providesTags: [{ type: 'NewOpenings' }],
    }),
  }),
});

export const {
  useGetAllNewsQuery,
  useLazyGetAllNewsQuery,
  useGetPublicNewsQuery,
  useLazyGetPublicNewsQuery,
  useGetNewsByIdQuery,
  usePostNewsMutation,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
  useLikeNewsMutation,
  useUnlikeNewsMutation,
  useCommentNewsMutation,
  useDeleteGnnCommentMutation,
  useViewNewsMutation,
  useMarkAsTop5NewsMutation,
  useGetTrendingNewsQuery,
  useLazyGetNewsByIdQuery,
  useGetTopNewsQuery,
  useGetNewOpeningsQuery,
  usePostReferralDataMutation,
  useGetNewTechnicalOpeningsQuery,
  useGetNewNonTechnicalOpeningsQuery,
  useGetCertificateDataQuery,
} = gnnApiSlice;
